const state = {
  lessons: [],
};

const actions = {
  updateLessons({ commit }, data) {
    commit("SET_LESSONS", data);
  },

  updateLessonSection({ commit }, section) {
    commit("SET_LESSON_SECTION", section);
  },
};

const mutations = {
  SET_LESSONS(state, data) {
    state.lessons = data;
  },
  SET_LESSON_SECTION(state, section) {
    let lessons = state.lessons;
    let lessonFindIdx = lessons.findIndex((item) => {
      return item.id === section.lesson_id;
    });
    if (lessonFindIdx >= 0) {
      const findIndex = lessons[lessonFindIdx].sections.findIndex((item) => {
        return item.id === section.id;
      });
      if (findIndex >= 0) {
        //update
        lessons[lessonFindIdx].sections[findIndex] = section;
      } else {
        lessons[lessonFindIdx].sections.push(section);
      }
      state.lessons = lessons;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
